import * as types from './actionTypes';

export const fetchOnboardingJobCode = (unit_id) => ({
  type: types.FETCH_ONBOARDING_JOB_CODE_REQUEST,
  payload: { unit_id },
});

export const fetchOnboardingImportList = (unit_id) => ({
  type: types.FETCH_ONBOARDING_IMPORT_LIST_REQUEST,
  payload: { unit_id },
});

export const saveOnboardingApplyJob = (payload) => ({
  type: types.SAVE_ONBOARDING_APPLY_JOB_REQUEST,
  payload,
});

export const fetchImportTemplate = (payload) => ({
  type: types.FETCH_IMPORT_TEMPLATE_REQUEST,
  payload,
});

export const uploadOnboardingImportFile = (payload) => ({
  type: types.UPLOAD_ONBOARDING_IMPORT_FILE_REQUEST,
  payload,
});

export const fetchOnboardingJobApproveList = (payload) => ({
  type: types.FETCH_ONBOARDING_JOB_APPROVE_LIST,
  payload,
});

export const saveOnboardingJobApprove = (payload) => ({
  type: types.SAVE_ONBOARDING_JOB_APPROVE,
  payload,
});

export const fetchOnboradingDropdownList = (unit_id) => ({
  type: types.FETCH_ONBOARDING_DROPDOWN_LIST,
  payload:{unit_id},
});

export const fetchOnboradingProcessList = (payload) => ({
  type: types.FETCH_ONBOARDING_PROCESS_LIST,
  payload,
});

export const fetchOnboradingAssignList = (payload) => ({
  type: types.FETCH_ONBOARDING_PROCESS_ASSIGN_LIST,
  payload,
});

export const changeOnboradingProcessStatus = (payload) => ({
  type: types.CHANGE_ONBOARDING_PROCESS_STATUS,
  payload,
});

export const saveOnboardingSchedulingProcess = (payload, callback) => ({
  type: types.SAVE_ONBOARDING_SCHEDULING_PROCESS,
  payload,
  callback,
});

export const updateApplicantsLevels = (payload) => ({
  type: types.UPDATE_APPLICANTS_LEVELS_REQUEST,
  payload,
});

export const fetchApplicantLevelDtls = (payload) => ({
  type: types.FETCH_APPLICANT_LEVEL_DTLS_REQUEST,
  payload,
});